import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import MenuCard from "../../component/MenuCard";
import VegIcon from "../../Assets/vegIcon.png"
import NonVegIcon from "../../Assets/nonVegIcon.png"
import '../../component/ListItem/listItem.css'
import './cartPage.css'
import LoginPage from "../Login";
import SelectItem from "../../component/MenuCard/SelectItem";
import { diet } from "../../Utills/enums";
import { placeOrder } from '../../redux/action';
import BackButton from "../../component/BackButton/BackButton";


const CartPage = () => {

    const { tableName, otp } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const menuList = useSelector((state) => state?.user?.menu);
    const fullCartState = useSelector((state) => state?.user?.cart);
    const user = useSelector((state) => state?.user?.user);

    const cart = fullCartState?.[tableName] || {}

    console.log("menuList", menuList)
    console.log("cart value in cartPage", cart)
    console.log("user", user)
    const cartItems = () => {
        const items = []
        Object.entries(cart).map(([cartKey, cartItem]) => {
            let item = menuList?.categories?.find(cat => cat.categoryId === cartItem.selectedTab)
                ?.items.find(menuItem => menuItem.menuId === cartItem.menuId);

            
            
            if (item) {
                const addonText = (cartItem.selectedAddons || []).map((a) => a.itemName).join(", ");

                // Add size information to display name if available
                const displayName = cartItem.selectedSize 
                    ? `${item.foodName} (${cartItem.selectedSize.sizeName})`
                    : item.foodName;
                
                items.push({ 
                    ...item, 
                    foodName: displayName,  // Override with size-appended name
                    addonSummary: addonText ? `Add-ons: ${addonText}` : "",
                    selectedTab: cartItem.selectedTab, 
                    selected: cartItem.selected,
                    price: cartItem.price,  // Use cart price (which includes size price)
                    selectedSize: cartItem.selectedSize,
                    selectedAddons: cartItem.selectedAddons,
                    cartKey: cartKey,  // Store cart key for reference
                    note:cartItem.note
                })
            }
        })
        return items ? items : <div> All caught </div>
    };

    const getTotalPrice = () => {
        let amount = 0
        Object.values(cart).map((val) => {
            amount += val.price * val.selected;
        })
        return amount;
    };

    const itemList = cartItems();
    const totalPrice = getTotalPrice();
    console.log("itemList...", itemList)
    const getOrderData = (pin) => {
        if (!itemList) return [];

        return Object.values(itemList).map(val => ({
            menuId: val.menuId,
            quantity: val.selected,
            price: val.price,
            tableOtp: otp, // pin ?? user.tableOtp ?? "550",
            qRScanLogId: null,            
            sizeOptionId: val.selectedSize?.sizeOptionId,
            addonItemIds: (val.selectedAddons || []).map((a) => a.addonItemId),
            addonSummary: val.addonSummary || null,
            note: val.note
        }));
    };

    const handlePlaceOrder = () => {
        // toast.success('Order Placed successfully');
        // toast.info("Order Placed successfully")
        dispatch(placeOrder(getOrderData(), tableName));
    };

    console.log("itemList", itemList)


    return (
        <div className="">
            <div className="cart-page items">
                <div className="cart-header">
                    <div className="cart-title">
                        {/* <span onClick={() => navigate(-1)} class="cart-back-btn">← Back</span> */}
                        <BackButton label="Back to Table" />
                        <span> <h2>Cart</h2></span>
                    </div>
                </div>
                <div className="lrSpace">
                    <ul className="no-bullets">
                        {/* todo: on click animation */}

                        {itemList.length === 0 ? <div> No Item to show</div> : itemList.map((val) =>
                            <MenuCard
                                key={val.cartKey || val.menuId}
                                cartKey={val.cartKey || val.menuId}
                                menuId={val.menuId}
                                src={val.imageUrl}
                                title={val.foodName}
                                description={val.description}
                                price={val.price}
                                dietIcon={diet[val.foodTypeId] === 'Veg' || diet[val.foodTypeId] === 'Vegan' ? VegIcon : NonVegIcon}
                                tab={val?.selectedTab}
                                unit={val}
                                ActionComponent={SelectItem}
                                isAvailable={val.isAvailable}
                                note={val?.note}
                                showNote={true}
                                tableName={tableName}
                            />
                        )}
                    </ul>
                    {/* <div>Offers and Benifits</div> */}
                    {/* <div className="payTitle">Payment Summary</div>
                <div className="priceRow">
                    <div className="yyy">Subtotal</div>
                    <div className="zzz"><b>{currency} {totalPrice}</b></div>
                </div>
                <div className="priceRow theameColor">
                    <div className="yyy">Discount</div>
                    <div className="zzz">{currency} 50</div>
                </div>
                <div className="priceRow">
                    <div className="yyy">Service Charges</div>
                    <div className="zzz">{currency} 20</div>
                </div>
                <div className="priceRow">
                    <div className="yyy"><b>Total amount</b></div>
                    <div className="zzz"><b>{currency} {totalPrice + 20 - 50}</b></div>
                </div> */}

                </div>


                {/* Bottom Sticky Bar */}
                {itemList.length > 0 && (

                    <div className="bottom-bar">
                        <div className="item-count">{itemList.length} Items</div>

                        <button className="place-order-btn"
                            onClick={handlePlaceOrder}
                        >
                            <span style={{ marginRight: 8 }}>🛒</span>
                            Place Order
                        </button>
                    </div>

                )}



            </div>

        </div>)
}

const styles = {
    bottomBar: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "5px 16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderTop: "1px solid #e4e4e4",

        boxShadow: "0 -2px 10px rgba(0,0,0,0.05)",
        marginTop: 10,
        backgroundColor: "#decea3"
    },

    itemCount: {
        padding: "12px 20px",
        color: "#d35400",
        borderRadius: "10px",
        fontSize: "16px",
        fontWeight: "600",
    },

    placeOrderBtn: {
        padding: "12px 20px",
        backgroundColor: "#fff",
        color: "#d35400",
        border: "none",
        borderRadius: "10px",
        fontSize: "16px",
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        border: "1px solid rgb(222, 206, 163)"
    },
    backButton: {
        cursor: "pointer",
        fontSize: "20px",
        fontWeight: "600",
        marginBottom: "10px",
        width: "fit-content",
        padding: "0px 2px",
        color: "rgb(251, 98, 54)"
    },
    cartButton: {
        fontSize: "16px",
        textAlign: "justify",
        color: "rgb(251, 98, 54)"
    }
};

export default CartPage;